export default __webpack_public_path__ + "static/media/PH-A524.74bb8486.webp";